export default "__VITE_PUBLIC_ASSET__31cfac26__"